import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { UserService } from 'src/app/dataServices/userService';
import { QuoteByUserId } from '../../models/quotes';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ConfigService } from 'src/app/services/configService';
import { SubdomainConfigService, ContactInfo } from 'src/app/services/subdomainConfig.service';

@Component({
    selector: 'self-ins-policies-and-request-page',
    templateUrl: './policies-and-request-page.html',
    styleUrls: ['./policies-and-request-page.scss'],
    standalone: false
})
export class PoliciesAndRequestsPageComponent implements OnInit {
    @Output() onChangeQuote = new EventEmitter<QuoteByUserId>();
    public user!: User;
    public quotes: QuoteByUserId[] = [];
    public selectedQuote: QuoteByUserId = {} as QuoteByUserId;
    public qnum = 0;
    public qsuffix = '';
    public wcPortalUrl = '';
    public email: string = '';
    public supportEmail: string = '';
    public claimsReportingUrl: string = '';

    public get wcCompQuoteUrl() {
        let params = [
            (this.user?.verificationInfo?.userName ? `applicantName=${this.user.verificationInfo.userName}` : ''),
            (this.user?.verificationInfo?.insuredName ? `insuredName=${this.user.verificationInfo.insuredName}` : ''),
            (this.user?.verificationInfo?.insuredAddress ? `insuredAddress=${this.user.verificationInfo.insuredAddress}` : ''),
            (this.user?.verificationInfo?.insuredCity ? `insuredCity=${this.user.verificationInfo.insuredCity}` : ''),
            (this.user?.verificationInfo?.insuredState ? `insuredState=${this.user.verificationInfo.insuredState}` : ''),
            (this.user?.verificationInfo?.insuredZip ? `insuredZip=${this.user.verificationInfo.insuredZip}` : ''),
            (this.user?.verificationInfo?.userPhone ? `phone=${this.user.verificationInfo.userPhone}` : '')
        ].filter(x => x).join('&');

        return `${this.wcPortalUrl}/?${params}`;
    }
    
    public constructor(private activeRouter: ActivatedRoute,
        private userService: UserService,
        private appState: AppState,
        private _datepipe: DatePipe,
        private config: ConfigService,
        private router: Router,
        public _translateService: TranslateHelperService,
        private subdomainConfigService: SubdomainConfigService
        ) {
            this.user = this.appState.user.getValue();
            this.wcPortalUrl = `${this.config.get('wcPortalUrl')}`;
            const contactInfo: ContactInfo = this.subdomainConfigService.getContactInfo();
            this.email = contactInfo.email;
            this.claimsReportingUrl = contactInfo.claimsReportingUrl;
            this.supportEmail = contactInfo.supportEmail;
        }

    public ngOnInit() {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];

            this.userService.getQuotes()
            .subscribe((quotes) => {
                    if (quotes) {
                        this.quotes = quotes;
                        if (this.qnum && this.qsuffix) {
                            this.selectedQuote = quotes.find(x => x.qnum === Number(this.qnum) 
                                                    && x.qsuffix === this.qsuffix) || {} as QuoteByUserId;
                        } else {
                            this.selectedQuote = quotes[0];
                            this.router.navigate(['/coverage'], {
                                queryParams: {
                                    qnum: this.selectedQuote.qnum,
                                    qsuffix: this.selectedQuote.qsuffix
                                }
                            });
                        }
                        this.onChangeQuote.emit(this.selectedQuote);
                    }
                });
        });
    }

    public activeQuote(index: number) {
        if (this.quotes &&
            this.quotes[index] &&
            this.selectedQuote.qnum == this.quotes[index].qnum &&
            this.selectedQuote.qsuffix == this.quotes[index].qsuffix) {
                return true;
        }
        return false;
    }

    public selectQuote(index: number) {
        if (this.quotes && this.quotes[index]) {
            this.router.navigate(['/coverage'], {
                queryParams: {
                    qnum: this.quotes[index].qnum,
                    qsuffix: this.quotes[index].qsuffix
                }
            });
        }
    }

    public getQuoteName(quote: QuoteByUserId) {
        if (quote.masterPolicyNumber) {
            return `${quote.linebusName} ${quote.masterPolicyNumber}`;
        } else {
            return `${quote.linebusName} ${quote.policyNumber}`;
        }
    }

    public getGeneralLiabilityEmailSubject(): string {
        const insuredName = this.user.verificationInfo && this.user.verificationInfo.insuredName ? this.user.verificationInfo.insuredName : '';
        const subject = this._translateService.translate(this._translateService.Keys.EMAIL_SUBJECTS_GENERAL_LIABILITY_REQUEST);
        return `${insuredName} ${subject}`;
    }
}
